import type { ReactNode } from 'react'

interface Props {
  label: string
  value: string | number
  delta?: string
  deltaPositive?: boolean
  icon?: ReactNode
  sparkline?: ReactNode
}

export default function StatCard({ label, value, delta, deltaPositive = true, icon, sparkline }: Props) {
  return (
    <div className="rounded-2xl border border-ica-border bg-ica-surface p-5">
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p className="text-sm font-medium text-ica-text-secondary">{label}</p>
          <p className="text-2xl font-bold tracking-tight">{value}</p>
          {delta && (
            <p className={`text-xs font-medium ${deltaPositive ? 'text-ica-accent' : 'text-ica-red'}`}>
              {delta}
            </p>
          )}
        </div>
        <div className="flex items-center gap-3">
          {icon && <div className="text-ica-text-muted">{icon}</div>}
          {sparkline}
        </div>
      </div>
    </div>
  )
}
